<template>
	<div class="server_index">
		<Row>
			<Col span="24">
				<Layout>
					<Sider hide-trigger class="side" width="300" height="700">
						<Menu :active-name="active_name" theme="dark" width="auto" @on-select="goto">
<!--							<MenuItem name="DashboardMain">-->
<!--								<Icon type="md-cog"></Icon>-->
<!--								<span>管理面板</span>-->
<!--							</MenuItem>-->
							<MenuItem name="DashboardCode">
								<Icon type="md-code"></Icon>
								<span>代码管理</span>
							</MenuItem>
<!--							<MenuItem name="DashboardServer">-->
<!--								<Icon type="md-desktop"></Icon>-->
<!--								<span>主机管理</span>-->
<!--							</MenuItem>-->
							<MenuItem name="DashboardMarkdown">
								<Icon type="logo-markdown"></Icon>
								<span>文档管理</span>
							</MenuItem>
							<MenuItem name="DashboardPerson">
								<Icon type="md-person"></Icon>
								<span>账号信息</span>
							</MenuItem>
						</Menu>
					</Sider>
					<Layout>
						<router-view></router-view>
					</Layout>
				</Layout>
			</Col>
		</Row>
	</div>
</template>

<script>
	import Server_List from "./server/server_list";

	export default {
		name: "index",
		data(){
			return {
				active_name: "DashboardMain",
			};
		},
		methods: {
			goto(name){
				this.$router.push({name});
			}
		},
		created(){
			this.active_name = this.$route.name;
		},
		components: {Server_List},
	}
</script>

<style scoped lang="less">
	.server_index {
		.side {
			color: white;
		}
	}
</style>
